import { render } from "./HallOfFameView.vue?vue&type=template&id=f2f6e3fe&scoped=true"
import script from "./HallOfFameView.vue?vue&type=script&lang=js"
export * from "./HallOfFameView.vue?vue&type=script&lang=js"

import "./HallOfFameView.vue?vue&type=style&index=0&id=f2f6e3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f6e3fe"]])

export default __exports__